import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import Hidden from '@material-ui/core/Hidden';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';

import GridHidden from '../GridHidden';
import SearchIcon from '../../shared/icons/Search';
import ClearIcon from '../../shared/icons/Close';

const useStyles = makeStyles(theme => ({
  searchInput: {
    display: 'flex',
    alignItems: 'flex-end',
    backgroundColor: theme.palette.sketch.grey3,
    padding: theme.spacing(2, 2, 3, 2),
    '& > svg': {
      marginRight: theme.spacing(1),
    },
  },
}));

const TitleSearch = props => {
  const { placeholder } = props;
  const classes = useStyles();

  const [hasFocus, setHasFocus] = React.useState(false);
  const handleFocus = () => {
    setHasFocus(true);
  };
  const handleBlur = () => {
    setHasFocus(false);
  };

  const handleChange = e => {
    props.onChange(e.target.value);
  };

  const clearQuery = () => {
    props.onChange('');
  };

  return (
    <Grid container spacing={2}>
      <GridHidden item sm={2} only="xs" />
      <Grid item xs={12} sm={8}>
        <div className={classes.searchInput}>
          <SearchIcon color={hasFocus ? 'primary' : 'inherit'} />
          <FormControl
            fullWidth
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleChange}
          >
            <InputLabel htmlFor={`search-filter-input-${placeholder}`}>
              {placeholder}
            </InputLabel>
            <Input
              id={`search-filter-inpu-${placeholder}`}
              value={props.value}
              endAdornment={
                <InputAdornment position="end">
                  {props.value && (
                    <IconButton size="small" onClick={clearQuery}>
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  )}
                </InputAdornment>
              }
            />
          </FormControl>
        </div>
      </Grid>
      <GridHidden item sm={2} only="xs" />
    </Grid>
  );
};

TitleSearch.defaultProps = {
  placeholder: 'placeholder',
};

export default TitleSearch;
